var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 799.465,
    height: 552.326,
    viewBox: "0 0 799.465 552.326",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    role: "img",
    artist: "Katerina Limpitsouni",
    source: "https://undraw.co/",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-560.267 -263.837)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1352.3,232.384H580.059a13.747,13.747,0,0,0-13.613,13.848v524.66a13.74,13.74,0,0,0,13.613,13.819H1352.3a13.741,13.741,0,0,0,13.613-13.819V246.232a13.747,13.747,0,0,0-13.611-13.848Z",
    transform: "translate(-6.18 31.452)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1328.244,232.384h-748.6a13.225,13.225,0,0,0-13.2,13.223V746.614a13.219,13.219,0,0,0,13.2,13.2h748.6a13.219,13.219,0,0,0,13.2-13.2V245.608a13.224,13.224,0,0,0-13.194-13.223Z",
    transform: "translate(-4.445 34.616)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1139.082 388.706) rotate(16)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 5.691,
    cy: 5.691,
    rx: 5.691,
    ry: 5.691,
    transform: "matrix(0.978, 0.208, -0.208, 0.978, 48.256, 156.005)",
    fill: "#ff6584"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 5.691,
    cy: 5.691,
    rx: 5.691,
    ry: 5.691,
    transform: "matrix(0.978, 0.208, -0.208, 0.978, 61.794, 218.231)",
    fill: "#623f8f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.157,2.4A37.788,37.788,0,0,1,30.714,19.911c.895,1.43,2.063,3,1.443,4.763a3.131,3.131,0,0,1-3.245,2.167,4.1,4.1,0,0,1-.424-7.909c4.133-1.763,8.3.962,11.67,3.136,7.671,4.955,16.109,9.436,25.4,10,8.6.522,17.823-2.85,22.607-10.308.837-1.3-1.241-2.511-2.074-1.212-4.744,7.4-14.335,10.053-22.675,8.91a44.081,44.081,0,0,1-14.188-4.817c-2.292-1.19-4.515-2.508-6.693-3.894a42.711,42.711,0,0,0-6.565-3.763c-3.828-1.572-8.9-1.45-11.57,2.171-2.495,3.378-.567,9,3.606,9.95a5.638,5.638,0,0,0,6.6-6.707c-.416-1.989-1.914-3.935-3.073-5.561A40.192,40.192,0,0,0,1.157,0c-1.545-.076-1.541,2.326,0,2.4Z",
    transform: "matrix(0.978, 0.208, -0.208, 0.978, 6.678, 88.826)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.361,23.636A30.055,30.055,0,0,1,45.853,9.712c-.712-1.138-1.641-2.388-1.148-3.788A2.491,2.491,0,0,1,47.286,4.2a3.264,3.264,0,0,1,.337,6.29c-3.287,1.4-6.6-.765-9.282-2.494C32.24,4.055,25.529.491,18.136.042,11.3-.374,3.96,2.308.155,8.24c-.666,1.038.987,2,1.649.964,3.773-5.883,11.4-8,18.034-7.087A35.061,35.061,0,0,1,31.123,5.949c1.823.946,3.591,1.995,5.324,3.1a33.97,33.97,0,0,0,5.221,2.993c3.045,1.251,7.075,1.153,9.2-1.727A5.243,5.243,0,0,0,48,2.4,4.484,4.484,0,0,0,42.75,7.734a13.084,13.084,0,0,0,2.444,4.423,31.967,31.967,0,0,0,24.167,13.39c1.229.061,1.226-1.85,0-1.91Z",
    transform: "matrix(0.978, 0.208, -0.208, 0.978, 99.169, 0)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.691,
    height: 18.7,
    transform: "matrix(0.978, 0.208, -0.208, 0.978, 148.191, 96.453)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.594,
    height: 18.379,
    transform: "matrix(-0.839, 0.545, -0.545, -0.839, 71.149, 62.693)",
    fill: "#b3b3b3"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.594,
    height: 18.379,
    transform: "matrix(-0.545, -0.839, 0.839, -0.545, 26.155, 266.634)",
    fill: "#ff6584"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-13.039 -3.954)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 92.961,
    cy: 92.961,
    rx: 92.961,
    ry: 92.961,
    transform: "translate(869.039 466.927)",
    fill: "#623f8f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.914,439.423a9.641,9.641,0,0,1-5.8-1.928l-.1-.078-21.847-16.712a9.709,9.709,0,0,1,11.814-15.41l14.151,10.852,33.439-43.625a9.7,9.7,0,0,1,13.606-1.8l0,0-.207.288.213-.288a9.716,9.716,0,0,1,1.8,13.609l-39.332,51.29a9.711,9.711,0,0,1-7.722,3.786Z",
    transform: "translate(574.869 155.927)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(883.473 402.745)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.38,83.907A3.391,3.391,0,0,1,0,80.525a3.138,3.138,0,0,1,.089-.79l17.5-77.091A3.4,3.4,0,0,1,23.207.9L81.231,54.628a3.4,3.4,0,0,1-1.291,5.737L4.4,83.755A3.49,3.49,0,0,1,3.38,83.907Z",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.447,9.784,0,2.531.574,0,32.8,6.406Z",
    transform: "translate(14.391 17.767)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.685,16.41,0,2.544.574,0,66.032,13.018Z",
    transform: "translate(9.852 37.726)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.282,9.693,44.052,11.31,0,2.544.573,0Z",
    transform: "translate(5.325 57.697)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 25.973)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.706,
    cy: 7.706,
    rx: 7.706,
    ry: 7.706,
    transform: "translate(740.977 560.345) rotate(-14)",
    fill: "#623f8f"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 5.504,
    cy: 5.504,
    rx: 5.504,
    ry: 5.504,
    transform: "translate(675.662 381.478) rotate(-14)",
    fill: "#ff6584"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 5.504,
    cy: 5.504,
    rx: 5.504,
    ry: 5.504,
    transform: "translate(707.357 525.615) rotate(-14)",
    fill: "#623f8f"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 5.504,
    cy: 5.504,
    rx: 5.504,
    ry: 5.504,
    transform: "translate(735.604 611.604) rotate(-14)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 5.504,
    cy: 5.504,
    rx: 5.504,
    ry: 5.504,
    transform: "translate(641.201 433.194) rotate(-14)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.645,47.494A29.066,29.066,0,0,1,38.357,24.655c-.065-1.3-.26-2.79.816-3.74a2.409,2.409,0,0,1,2.992-.239,3.157,3.157,0,0,1-2.68,5.471c-3.437-.365-5.216-3.759-6.662-6.481-3.3-6.2-7.283-12.377-13.314-16.241C13.927-.151,6.468-1.343.459,1.873-.592,2.436.351,4.024,1.4,3.465c5.959-3.19,13.4-1.378,18.57,2.516a33.907,33.907,0,0,1,7.724,8.554c1.094,1.658,2.092,3.377,3.036,5.125a32.862,32.862,0,0,0,3,4.989c1.982,2.491,5.431,4.309,8.585,2.879a5.071,5.071,0,0,0,1.308-8.035,4.337,4.337,0,0,0-6.95,2.029,12.649,12.649,0,0,0-.021,4.887,30.916,30.916,0,0,0,14.1,22.7c1.009.631,1.907-.984.9-1.613Z",
    transform: "translate(733.256 507.476) rotate(-14)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.41,
    height: 17.775,
    transform: "translate(666.508 506.419) rotate(-149)",
    fill: "#b3b3b3"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.706,
    cy: 7.706,
    rx: 7.706,
    ry: 7.706,
    transform: "translate(649.977 619.049) rotate(-14)",
    fill: "#623f8f"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.04a584469c8abdb824016adad80601f0.svg";
export { ForwardRef as ReactComponent };